import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { formatDateString } from "../../util/common"
import styles from "./blog-list-row.module.css";

export const BlogListRow = ({ data }) => {
    let { title, published_at, description, slug } = data.node;
    const [createdAt, setCreatedAt] = useState('');
    useEffect(() => {
        const dateString = formatDateString(published_at);
        setCreatedAt(dateString);
    }, [published_at])
    return (
        <article className={`clear ${styles['blog_list_row']}`} >
            <Link to={`/blogs/${slug}`}>
                <h1 className="gray">{title}</h1>
                <small className={`white ${styles['published_date']}`}>{createdAt}</small>
            </Link>
            <p className={`white ${styles['description']}`}>{description}</p>
        </article>
    )
}